import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import StandardsMarquee from "@/components/landing/StandardsMarquee";
import Services from "@/components/landing/Services";
import Approach from "@/components/landing/Approach";
import WhoWeServe from "@/components/landing/WhoWeServe";
import Standards from "@/components/landing/Standards";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="bg-white text-bpo-ink">
            <Header />
            <Hero />
            <StandardsMarquee />
            <Services />
            <Approach />
            <WhoWeServe />
            <Standards />
            <Testimonials />
            <Contact />
            <Footer />
        </main>
    );
}
